import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy, OnChanges } from '@angular/core';

export interface OverflowMenuOptions {
  id: string;
  label: string;
  field?: string;
  condition?: any;
  subfield?: string;
  subcondition?: any;
  hide?: any;
}

@Component({
  standalone: false,
  selector: 'lib-overflow-menu',
  templateUrl: './overflow-menu.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./overflow-menu.component.scss']
})
export class OverflowMenuComponent implements OnChanges {
  @Input() options: OverflowMenuOptions[] = [];
  @Input() data: any;
  @Output() optionClicked: EventEmitter<string> = new EventEmitter<string>();
  sortedOptions: OverflowMenuOptions[] = [];

  constructor() {}

  ngOnChanges(): void {
    this.sortedOptions = [...(this.options ?? [])].sort((a, b) => a.label.localeCompare(b.label));
  }

  trackById(index: number, item: any) {
    return item.id;
  }
}
